import React from 'react'
import styles from './index.less'

// 分页器
const StickyFootBar = ({ left, right }: any) => {
    return (
        <div className={styles.stickyFootBar}>
            <div className={styles.lt}>{left}</div>
            <div className={styles.rt}>{right}</div>
        </div>
    )
}

export default StickyFootBar
